import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { queryClient } from '@hero/clients';
import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useUpdateContact = options => {
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(({ id, body }) => contactServices.updateContact(id, body), {
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetContactKey] }); //! for contact-detail
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetContactsKey] }); //! for contact-list

      showSuccess({
        message: t('contactIsUpdated'),
        type: 'toast'
      });
    }
  });
};
